export const DueDiligenceRoutes = {
    DueDiligence: "due-diligence",
    RequestDueDiligence: "request-due-diligence"
}